import { render, staticRenderFns } from "./HeaderInstagramStories.vue?vue&type=template&id=276a1862"
import script from "./HeaderInstagramStories.vue?vue&type=script&lang=js"
export * from "./HeaderInstagramStories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InstagramStoriesViewer: require('/app/components/InstagramStoriesViewer.vue').default})
